<template>
    <div class="form-group col-12">
        <div :key="`common-groups-${componentKey}`">
            <group
                v-for="(group, index) of content.commonGroups"
                :key="group.id"
                :group="group"
                :v="v.commonGroups.$each[index]"
                :server-errors="commonGroupErrors(index)"
            />
        </div>

        <div class="col-xl-12 mb-5 mt-4">
            <div class="card mb-2">
                <div class="card-body">
                    <label> Campus </label>
                    <campus-selector
                        v-if="content.campusId"
                        :value="content.campusId"
                        @input="$emit('campus-change', $event)"
                    />
                </div>
            </div>
        </div>

        <div :key="`groups-${componentKey}`">
            <group
                v-for="(group, index) of content.groups"
                :key="group.id"
                :group="group"
                :v="v.groups.$each[index]"
                :server-errors="groupErrors(index)"
            />
        </div>
    </div>
</template>

<script>
import Group from '@/components/about/Group';
import CampusSelector from '@/components/campuses/Selector';

export default {
    components: {
        Group,
        CampusSelector
    },

    props: {
        value: {
            type: Object,
            required: true,
            default: () => ({})
        },
        v: {
            type: Object,
            required: true,
            default: () => ({})
        },
        serverErrors: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            componentKey: 0,
            content: {}
        };
    },

    watch: {
        content: {
            handler() {
                this.$emit('input', this.content);
            },
            deep: true
        },

        value: {
            handler() {
                if (this.content.campusId !== this.value.campusId) {
                    this.content = { ...this.value };
                    this.componentKey++;
                }
            },
            deep: true
        }
    },

    mounted() {
        this.content = { ...this.value };
    },

    methods: {
        commonGroupErrors(index) {
            return this.serverErrors.filter(({ param }) =>
                param.includes(`commonGroups[${index}]`)
            );
        },

        groupErrors(index) {
            return this.serverErrors.filter(({ param }) =>
                param.includes(`groups[${index}]`)
            );
        }
    }
};
</script>
